export const removeOptionality = <T extends Record<string, unknown>>(
    obj: T
): { [K in keyof T]-?: Exclude<T[K], undefined> } => {
    const filtered = Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
    return filtered as { [K in keyof T]-?: Exclude<T[K], undefined> };
};
